import Vue from 'vue'
import LoadingComponent from './index.vue'

// 单例：全局唯一实例
let instance = null

// 基于组件创建构造器
const LoadingConstructor = Vue.extend(LoadingComponent)

// 获取或创建单例实例
function getInstance() {
  if (!instance) {
    instance = new LoadingConstructor().$mount()
    document.body.appendChild(instance.$el)
  }
  return instance
}

// 插件 install 方法
const LoadingPlugin = {
  install(Vue) {
    Vue.prototype.$loading = {
      show(options = {}) {
        getInstance().show(options)
      },
      hide() {
        if (instance) {
          instance.hide()
        }
      }
    }
  }
}

export default LoadingPlugin